import BaseTransformer from "./base.transformer"
import ProjectTransformer from "./project.transformer"
import ThemeTransformer from "./theme.transformer"
import QrUrlFormatter from "@/formatters/QrUrlFormatter"
import QrDesignsTransformer from "./qrDesigns.transformer"

export const baseUri = "/api/qrs"
const states = {
  0: "deleted",
  1: "paused",
  2: "active"
}

const criteriaIdentifier = {
  1: "account",
  2: "project",
  3: "qr"
}

export const criteriaNumericIdentifier = {
  account: 1,
  project: 2,
  qr: 3
}
// 08594159531666
function getSettings(settings) {
  let _settings = {}

  if (settings && settings.forEach) {
    settings.forEach((setting) => {
      _settings[setting.id] = setting
    })
  }

  return _settings
}
class QrTransformer extends BaseTransformer {
  static fetch(qr) {
    const uuid = this.transformUuid(qr)

    const qrTransformed = this.removeEmptyProps({
      uuid,
      iri: this.uuidToIri(baseUri, uuid),
      title: qr.title,
      domain: qr.domain,
      gS1Validated: qr.gS1Validated,
      updatedAt: qr.updatedAt,
      pathName: qr.pathName,
      state: states[qr.state],
      status: qr.status,
      url: QrUrlFormatter.shortenUrl(qr.url),
      input: qr.input || {},
      settings: getSettings(qr.settings),
      assetUrl: qr.previewUrl,
      design: QrDesignsTransformer.fetch(
        typeof qr.design === "string" ? { uuid: qr.typology.split("/").pop() } : qr.design
      ),
      project: qr.project
        ? ProjectTransformer.fetch(
            typeof qr.project === "string" ? { uuid: qr.project?.split("/").pop() } : qr.project
          )
        : null,
      theme: qr.theme
        ? ThemeTransformer.fetch(
            typeof qr.theme === "string" ? { uuid: qr.theme?.split("/").pop() } : qr.theme
          )
        : null
    })
    // let assetSVG = await GeneratePreviewQrHandler.apply(qrTransformed)
    // qrTransformed.assetSVG = assetSVG
    return qrTransformed
  }

  static fecthCriteria({ criteria }) {
    const criteriaFormatted = {}

    Object.keys(criteria).forEach(
      (key) => (criteriaFormatted[criteriaIdentifier[key]] = criteria[key])
    )

    return criteriaFormatted
  }
}

export default QrTransformer
